import React from "react";
import { getDateFormate } from "../../utils/timeformate";

const YearRange = ({ fromYear, toYear }) => {
  if (!fromYear) return null;

  const start = new Date(fromYear);
  const end =
    !toYear || toYear === "Present"
      ? new Date()
      : new Date(toYear);

  if (isNaN(start.getTime()) || isNaN(end.getTime())) return null;

  let years = end.getFullYear() - start.getFullYear();
  let months = end.getMonth() - start.getMonth();
  let days = end.getDate() - start.getDate();

  if (days < 0) months--;
  if (months < 0) {
    years--;
    months += 12;
  }

  let displayText = "";

  if (years <= 0 && months <= 0) {
    displayText = "< 1 Month";
  } else if (years <= 0) {
    displayText = `${months} Month${months > 1 ? "s" : ""}`;
  } else if (months === 0) {
    displayText = `${years} Year${years > 1 ? "s" : ""}`;
  } else {
    displayText = `${years} Year${years > 1 ? "s" : ""} ${months} Month${months > 1 ? "s" : ""
      }`;
  }

  return (
    <p>
      {getDateFormate(start)} -{" "}
      {toYear === "Present" || !toYear
        ? "Present"
        : getDateFormate(end)}{" "}
      <span>({displayText})</span>
    </p>
  );
};

export default YearRange;
